import { render } from "./comparison-grid-large.vue?vue&type=template&id=4f704647&scoped=true"
import script from "./comparison-grid-large.vue?vue&type=script&lang=js"
export * from "./comparison-grid-large.vue?vue&type=script&lang=js"

import "./comparison-grid-large.vue?vue&type=style&index=0&id=4f704647&scoped=true&lang=scss"

import exportComponent from "/builds/bluemantis/origo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f704647"]])

export default __exports__